import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/nurseOffice',
  component: Layout,
  name: 'nurseOffice',
  redirect: '/nurseOffice/index',
  children: [{
    path: '/nurseOffice/index',
    component: () => import('@/views/nurseOffice/index'),
    name: 'nurseOffice.index',
    meta: {
      title: i18n.t(`message.nurse_office`)
    }
  }, ]
}

export default schedule